import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getAreaList = (params, options) =>
  request.get(
    '/api/blade-system/region/lazy-tree',
    Object.assign({}, options, { params })
  );

  export const getAreaExtend = (params, options) =>
  request.get(
    '/api/blade-system/region/lazy-tree-extend',
    Object.assign({}, options, { params })
  );

  export const nursingPage = (params, options) =>
  request.get(
    '/api/nursing/page',
    Object.assign({}, options, { params })
  );

  export const nursingSave= (params, options) =>
  request.post('/api/nursing/save', params, options);
  export const nursingDetail = (params, options) =>
  request.get(
    '/api/nursing/detail',
    Object.assign({}, options, { params })
  );

  export const nursingUpdate= (params, options) =>
  request.post('/api/nursing/update', params, options);

  export const nurforRemove= (id) =>
request.post('/api/nursing/remove?ids='+id);

  // 评估模块接口
  export const getList = params => {
    return request({
      url: '/api/nursing/template/list',
      method: 'get',
      params
    })
  }

  export const getDetail = (id) => {
    return request({
      url: '/api/nursing/template/detail',
      method: 'get',
      params: {
        id
      }
    })
  }

  export const remove = (ids) => {
    return request({
      url: '/api/nursing/template/remove',
      method: 'post',
      params: {
        ids,
      }
    })
  }

  export const add = (row) => {
    return request({
      url: '/api/nursing/template/save',
      method: 'post',
      data: row
    })
  }

  export const update = (row) => {
    return request({
      url: '/api/nursing/template/update',
      method: 'post',
      data: row
    })
  }
